import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AuthSliceState {
  authToken: string | null;
}

const initialState: AuthSliceState = {
  authToken: null,
};

const AuthSlice = createSlice({
  name: 'authReducer',
  initialState,
  reducers: {
    setAuthAccessToken: (state, action: PayloadAction<string>) => {
      state.authToken = action.payload;
    },
    clearToken: (state) => {
      state.authToken = null;
    },
  },
});

export const { setAuthAccessToken, clearToken } = AuthSlice.actions;
export default AuthSlice.reducer;
